import { ServerResponse, UserDataTypes } from "./types";

export function setAuth(data: ServerResponse) {
  return {
    type: UserDataTypes.AUTH_SET,
    payload: data,
  };
}
export function beginAuthentication(path: string) {
  return {
    type: UserDataTypes.AUTHENTICATE,
    payload: { path },
  };
}
export function checkAuth(path: string) {
  return {
    type: UserDataTypes.AUTH_CHECK,
    payload: { path }
  };
}
export function setAuthError() {
  return {
    type: UserDataTypes.AUTH_ERROR,
  };
}
export function initiateLogout() {
  return {
    type: UserDataTypes.AUTH_LOGOUT,
  };
}

export function setSystemError() {
  return {
    type: UserDataTypes.SET_SYSTEM_ERROR,
  };
}
